import {Component, OnDestroy, OnInit} from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { Account } from 'msal';
import {MatMenuModule} from '@angular/material/menu';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'ral-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit, OnDestroy {
  title = 'RalarsaWeb';
  loggedIn: boolean = false;

  constructor(private msalService: MsalService, private route: ActivatedRoute, private router: Router) {
  }

  async ngOnInit(): Promise<void> {
    await this.isLoggedIn()
    if (! this.loggedIn) {
      document.body.className = "selector";
    } else {
      document.body.className = "";
    }
  }

  ngOnDestroy() {
    document.body.className = "";
  }

  async isLoggedIn(): Promise<void> {
    //Esperamos a que termine navegacion para obtener la ruta actual
    const currentRoute = await new Promise<string>((resolve) => {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          resolve(event.urlAfterRedirects);
        }
      });
    });

    //con esto se evita que se muestre el login normal en la pagina de login externo
    if (currentRoute.includes('/externo') || localStorage.getItem("accessToken") != null) {
      this.loggedIn = true;
      return;
    }

    if (this.msalService.instance.getActiveAccount() == null || this.msalService.instance.getActiveAccount() == undefined){
      this.loggedIn = false;
      return;
    }

    try {
      await this.msalService.acquireTokenSilent({
        scopes: ['GroupMember.Read.All']
      }).toPromise();
      this.loggedIn = true;
      this.router.navigate([currentRoute]);
    } catch (error) {
      this.loggedIn = false;
    }
  }

  async login() {
    await this.msalService.instance.handleRedirectPromise();

    this.msalService.instance.loginPopup().then(
      (response) => {
        this.msalService.instance.setActiveAccount(response.account);
        document.body.className = "";
        this.loggedIn = true;
      }).catch(function (error) {
    });
  }
}
